var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.1457 25.8131L8.67099 14.8504L0.196289 3.88779L13.9276 2.0298L27.6588 0.171815L22.4023 12.9924L17.1457 25.8131Z","fill":"#7C588F"}));
}

Triangle.defaultProps = {"width":"28","height":"26","viewBox":"0 0 28 26","fill":"none"};

module.exports = Triangle;

Triangle.default = Triangle;
